import { ICompanyState } from 'types';

export const initState: ICompanyState = {
  company: null,
  isCompanyLoading: false,
};
